import React, {useContext} from 'react'
import {ToggleContext} from '@/builder/blocks/toggle'
import PropTypes from 'prop-types'

export function ToggleButton({children, attributes}) {
    const {setIsOpen} = useContext(ToggleContext)
    return (
        <button {...attributes} onClick={() => setIsOpen((isOpen) => !isOpen)}>
            {children}
        </button>
    )
}

ToggleButton.propTypes = {
    children: 'Toggle Search',
    attributes: PropTypes.object
}
export const ToggleButtonDefinition = {
    component: ToggleButton,
    name: 'ToggleButton',
    canHaveChildren: true,
    hideFromInsertMenu: true,
    noWrap: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/toggle-off.svg',
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'Text',
                options: {text: 'Click me'}
            }
        }
    ]
}
